var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-0",attrs:{"icon":"","color":_vm.color,"href":_vm.link,"target":"_blank"}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }